export const SHOW = `Показать все`;
export const HIDE = `Скрыть`;
